"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var axios_1 = __importDefault(require("axios"));
var DetailDataSingleLabel_1 = __importDefault(require("../contract_form/DetailDataSingleLabel"));
var date_parser_1 = __importDefault(require("../../../common/src/utils/date/date_parser"));
var SalesForceButtonArea_1 = __importDefault(require("./SalesForceButtonArea"));
var DatePickerWrapper_1 = __importDefault(require("../datepicker/DatePickerWrapper"));
var value_checker_1 = __importDefault(require("../../../common/src/utils/validation/value_checker"));
var ReflectType_1 = require("../../../common/src/types/sales_force/ReflectType");
var MoveSalesForceButton_1 = __importDefault(require("./MoveSalesForceButton"));
var SimpleDialog_1 = __importDefault(require("../globals/SimpleDialog"));
var PriceBookSelect_1 = __importDefault(require("./PriceBookSelect"));
var ProductSelect_1 = __importDefault(require("./ProductSelect"));
var Loading_1 = __importDefault(require("../../components/globals/Loading"));
var object_utils_1 = __importDefault(require("../../../common/src/utils/sales_force/object_utils"));
var sales_force_input_utils_1 = __importDefault(require("../../../common/src/constrains/sales_force_input/sales_force_input_utils"));
var sales_force_input_const_1 = __importDefault(require("../../../common//src/constrains/sales_force_input/sales_force_input_const"));
var OpportunityUpgradePre = /** @class */ (function (_super) {
    __extends(OpportunityUpgradePre, _super);
    function OpportunityUpgradePre() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.form = {};
        _this.showAlertDialog = false;
        _this.alertMessage = '';
        _this.showConfirmDialog = false;
        _this.confirmMessage = '';
        _this.salesForceInfo = {
            torihikisakiId: '',
            toUpgradeItFlg: '',
            toUpgradeTokubetuFlg: '',
            toUpgradeTokubetuDetail: '',
            opportunityToUpgradeId: '',
            opportunityToUpgradeName: '',
            toUpgradePriceBook2Id: '',
            opportunityToUpgradeItemId: '',
            toUpgradeProductId: '',
            toUpgradePriceBookData: [],
            toUpgradeData: [],
            toUpgradeStartDate: '',
            toUpgradeSelectedItem: '',
            toUpgradePlanName: '',
            toUpgradeCapacity: '',
            toUpradePlanPeriodStr: '',
            toUpgradePrice: '',
            currentContractEndDate: '',
            currentContractStartDate: '',
            toUpgradePeriod: '',
            toUpgradeContractEdate: '',
            toUpgradeRequestStartDate: '',
            toUpgradePriceBookMonth: ''
        };
        _this.alertDialogMessage = '';
        _this.loading = false;
        // [Rehab Cloud]のみの価格表
        _this.rehabCloudPriceBook = [];
        _this.selectedItem = '';
        _this.contractSdate = '';
        _this.contractMinimumDate = '2023-01-01';
        _this.toUpgradeSelectedItemDisabled = true;
        _this.toUpgradeStartDateDisabled = true;
        _this.isSelectUpgradeCapacity = false;
        _this.selectedUpgradeCapacity = '';
        return _this;
    }
    Object.defineProperty(OpportunityUpgradePre.prototype, "items", {
        get: function () {
            var self_ = this;
            var familyName = self_.upgradeToStandardDataList.familyName ===
                self_.$t('view.sales_force.reflect.label.opportunity.upgrade') ? self_.$t('view.sales_force.reflect.label.opportunity.upgrade') : self_.upgradeToStandardDataList.familyName;
            return sales_force_input_utils_1.default.getDisplayTextList(familyName, self_.upgradeToStandardDataList.product2Family, self_.upgradeToStandardDataList.product2Name, self_.upgradeToStandardDataList.forUpgradePreviousPlan);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OpportunityUpgradePre.prototype, "upgradeCapacityItems", {
        get: function () {
            return sales_force_input_const_1.default.UPGRADE_CAPACITY;
        },
        enumerable: true,
        configurable: true
    });
    OpportunityUpgradePre.prototype.handleSelectChange = function () {
        var self_ = this;
        switch (self_.salesForceInfo.toUpgradeSelectedItem) {
            case 'Entry to Standard':
                self_.salesForceInfo.previousPlan = 'Rehab Cloud Entry';
                self_.salesForceInfo.contractPlan = 'Rehab Cloud Standard';
                break;
            case 'Entry to Pro':
                self_.salesForceInfo.previousPlan = 'Rehab Cloud Entry';
                self_.salesForceInfo.contractPlan = 'Rehab Cloud Pro';
                break;
            case 'Basic to Medium':
                self_.salesForceInfo.previousPlan = 'Rehab Cloud Basic';
                self_.salesForceInfo.contractPlan = 'Rehab Cloud Medium';
                break;
            case 'Basic to Standard':
                self_.salesForceInfo.previousPlan = 'Rehab Cloud Basic';
                self_.salesForceInfo.contractPlan = 'Rehab Cloud Standard';
                break;
            case 'Basic to Pro':
                self_.salesForceInfo.previousPlan = 'Rehab Cloud Basic';
                self_.salesForceInfo.contractPlan = 'Rehab Cloud Pro';
                break;
            case 'Medium to Standard':
                self_.salesForceInfo.previousPlan = 'Rehab Cloud Medium';
                self_.salesForceInfo.contractPlan = 'Rehab Cloud Standard';
                break;
            case 'Medium to Pro':
                self_.salesForceInfo.previousPlan = 'Rehab Cloud Medium';
                self_.salesForceInfo.contractPlan = 'Rehab Cloud Pro';
                break;
            case 'Standard to Pro':
                self_.salesForceInfo.previousPlan = 'Rehab Cloud Standard';
                self_.salesForceInfo.contractPlan = 'Rehab Cloud Pro';
                break;
            default:
                self_.salesForceInfo.previousPlan = '';
                self_.salesForceInfo.contractPlan = '';
        }
    };
    OpportunityUpgradePre.prototype.refs = function () {
        return this.$refs;
    };
    OpportunityUpgradePre.prototype.getTranslation = function (key) {
        return this.$t(key);
    };
    OpportunityUpgradePre.prototype.parseDate = function (dateStr) {
        return date_parser_1.default.toJapaneseDateStr(dateStr);
    };
    OpportunityUpgradePre.prototype.mounted = function () {
        this.initDataChange();
        this.initSalesForceDataChange();
        this.salesForceAutoComplete();
        this.capacitySelectBoxCtrl();
    };
    OpportunityUpgradePre.prototype.startLoading = function () {
        this.loading = true;
    };
    OpportunityUpgradePre.prototype.endLoading = function () {
        this.loading = false;
    };
    OpportunityUpgradePre.prototype.priceBookChange = function (newBookInfo) {
        this.salesForceInfo.upgradePriceBook2Name = newBookInfo['name'];
        this.salesForceInfo.upgradePriceBook2Description = newBookInfo['description'];
        this.salesForceInfo.upgradePriceBookUrl = newBookInfo['url'];
        this.salesForceInfo.upgradePriceBookBillWay = newBookInfo['BillWay'];
    };
    OpportunityUpgradePre.prototype.initDataChange = function () {
        this.form = this.initData;
    };
    OpportunityUpgradePre.prototype.initSalesForceDataChange = function () {
        this.salesForceInfo = this.initSalesForceData;
    };
    OpportunityUpgradePre.prototype.capacitySelectBoxCtrl = function () {
        // 現状はEntryからのアップグレードの場合、定員数の選択を有効化する。Entry以外の選択肢が現れた場合は、ここに追加する。
        this.isSelectUpgradeCapacity = this.upgradeToStandardDataList.familyName === this.$t('view.sales_force.reflect.label.opportunity.entry');
    };
    OpportunityUpgradePre.prototype.priceBook2IdChanged = function () {
        if (value_checker_1.default.isPresent(this.salesForceInfo.toUpgradePriceBook2Id)) {
            // 必要な商品をSETする。
            this.defaultPriceBookData();
            // アップグレード対象商談の契約終了日を決定する
            this.decideUpgradeBaseDate();
            // アップグレード先／利用開始月の入力を有効化する
            this.toUpgradeSelectedItemDisabled = false;
            this.toUpgradeStartDateDisabled = false;
        }
    };
    // アップグレード先のプラン（セレクトボックス）の変更を監視する
    OpportunityUpgradePre.prototype.decideToUpgradePlan = function () {
        if (value_checker_1.default.isPresent(this.salesForceInfo.toUpgradeSelectedItem) &&
            value_checker_1.default.isPresent(this.salesForceInfo.toUpgradeStartDate) &&
            value_checker_1.default.isPresent(this.salesForceInfo.toUpgradeCapacity) &&
            this.defaultPriceBookDataObj.length > 0) {
            this.alterPlanData();
        }
    };
    // アップグレード先の利用開始月の変更を監視する
    OpportunityUpgradePre.prototype.determineToUpgradePlan = function () {
        if (value_checker_1.default.isPresent(this.salesForceInfo.toUpgradeSelectedItem) &&
            value_checker_1.default.isPresent(this.salesForceInfo.toUpgradeStartDate) &&
            value_checker_1.default.isPresent(this.salesForceInfo.toUpgradeCapacity) &&
            this.defaultPriceBookDataObj.length > 0) {
            this.alterPlanData();
        }
    };
    // アップグレード先の定員数の変更を監視する（主にEntryのため）
    OpportunityUpgradePre.prototype.determineToUpgradePlanByCapacity = function (newVal) {
        if (this.defaultPriceBookDataObj.length > 0) {
            if (newVal !== this.salesForceInfo.toUpgradeCapacity) {
                this.salesForceInfo.toUpgradeCapacity = newVal;
                this.alterPlanData();
            }
        }
    };
    OpportunityUpgradePre.prototype.salesForceAutoComplete = function () {
        if (value_checker_1.default.isBlank(this.salesForceInfo.opportunityToUpgradeName)) {
            this.salesForceInfo.opportunityToUpgradeName = this.form.officeInfoOfficeName + "_" + date_parser_1.default.toString(new Date());
        }
    };
    OpportunityUpgradePre.prototype.alterPlanData = function () {
        var _this = this;
        var filteringList = null;
        // 2024年3月31日までの期間限定のアップグレード商品を選択する判定
        var isLimitedPeriodWithIn = object_utils_1.default.isWithinPeriod('2023-12-01', '2024-03-31', this.salesForceInfo.toUpgradeStartDate);
        var diffMonth = object_utils_1.default.compareBwetweeYearMonth(this.salesForceInfo.currentContractEndDate, this.salesForceInfo.toUpgradeStartDate, "YearMonth");
        // アップグレード先のプランが「Basic to Standard」の場合、期間限定のアップグレード商品を選択する
        if (this.salesForceInfo.toUpgradeSelectedItem === 'Basic to Standard' && isLimitedPeriodWithIn) {
            filteringList = this.defaultPriceBookDataObj.filter(function (v) {
                return v.text.includes('Rehab Cloud Standard アップグレード');
            });
        }
        else {
            filteringList = this.defaultPriceBookDataObj.filter(function (v) {
                return !v.text.includes('Rehab Cloud Standard アップグレード');
            });
        }
        // 当月も含めるため＋１ヶ月とする
        diffMonth = diffMonth + 1;
        var computedChoiceOutcomes = filteringList.filter(function (v) {
            return v.previousPlan === _this.salesForceInfo.previousPlan &&
                v.contractPlan === _this.salesForceInfo.contractPlan &&
                v.monthCount === diffMonth.toString() &&
                v.capacity === _this.salesForceInfo.toUpgradeCapacity;
        });
        if (this.items) {
            this.items.filter(function (v) {
                var isEntryTo = v.displayText.includes('Entry to');
                var hasUpgradeInfo = value_checker_1.default.isPresent(_this.salesForceInfo.toUpgradeSelectedItem) &&
                    value_checker_1.default.isPresent(_this.salesForceInfo.toUpgradeStartDate);
                var hasCapacity = value_checker_1.default.isPresent(_this.salesForceInfo.toUpgradeCapacity);
                if ((isEntryTo && hasUpgradeInfo && hasCapacity) || (!isEntryTo && hasUpgradeInfo)) {
                    // yyyy年mm月dd日〜yyyy年mm月dd日までを算出する。
                    _this.salesForceInfo.toUpradePlanPeriodStr = object_utils_1.default.getPlanPeriodStr(_this.salesForceInfo.toUpgradeStartDate, '', diffMonth.toString(), computedChoiceOutcomes[0].period);
                    // アップグレード商品の価格
                    _this.salesForceInfo.toUpgradePrice = value_checker_1.default.isBlank(computedChoiceOutcomes[0].price) ? '' : computedChoiceOutcomes[0].price;
                    // アップグレード商品のプラン名
                    _this.salesForceInfo.toUpgradePlanName = value_checker_1.default.isBlank(computedChoiceOutcomes[0].text) ? '' : computedChoiceOutcomes[0].text;
                }
            });
        }
        // アップグレード商品のプラン
        this.salesForceInfo.toUpgradePeriod = value_checker_1.default.isBlank(computedChoiceOutcomes[0].period) ? '' : computedChoiceOutcomes[0].period;
        // 商品ID
        this.salesForceInfo.toUpgradeProductId = value_checker_1.default.isBlank(computedChoiceOutcomes[0].value) ? '' : computedChoiceOutcomes[0].value;
        // 月数
        this.salesForceInfo.toUpgradePriceBookMonth = value_checker_1.default.isBlank(computedChoiceOutcomes[0].monthCount) ? '' : computedChoiceOutcomes[0].monthCount;
    };
    OpportunityUpgradePre.prototype.decideUpgradeBaseDate = function () {
        var _this = this;
        if (this.upgradeToStandardDataList) {
            // Object型のプロパティから、現状の契約開始日と契約終了日、キャパシティを取得する
            this.salesForceInfo.toUpgradeCapacity = this.upgradeToStandardDataList.capacity;
            this.salesForceInfo.currentContractStartDate = this.upgradeToStandardDataList.contractStartDate;
            this.salesForceInfo.currentContractEndDate = this.upgradeToStandardDataList.contractEndDate;
            if (this.items) {
                this.items.filter(function (v) {
                    if (v.displayText.includes('Entry to') || v.displayText.includes('Medium to') || v.displayText.includes('Standard to')) {
                        _this.contractMinimumDate = '2024-04-01';
                    }
                    else {
                        _this.contractMinimumDate = _this.salesForceInfo.currentContractStartDate;
                    }
                });
            }
        }
        else {
            this.alertMessage = "アップグレード対応でERRORが発生しています。開発にご連絡下さい2";
            this.showAlertDialog = true;
        }
    };
    // ワイルドカードによる文字列の一致判定
    OpportunityUpgradePre.prototype.checkWildcardMatch = function (text, pattern) {
        var regexp = new RegExp(pattern.replace(/\*/g, '.*'));
        return regexp.test(text);
    };
    OpportunityUpgradePre.prototype.defaultPriceBookData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var self_, authToken, url_, response, productItems, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (value_checker_1.default.isBlank(this.salesForceInfo.toUpgradePriceBook2Id)) {
                            this.alertMessage = "アップグレード対応でERRORが発生しています。開発にご連絡下さい3";
                            this.showAlertDialog = true;
                            return [2 /*return*/];
                        }
                        self_ = this;
                        self_.startLoading();
                        return [4 /*yield*/, this.$cognito.authToken()];
                    case 1:
                        authToken = _a.sent();
                        url_ = this.$invokeUrlMaker.create("sales_force/get_pricebook_entry/" + self_.salesForceInfo.toUpgradePriceBook2Id);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, axios_1.default.get(url_, {
                                headers: {
                                    Authorization: "Bearer " + authToken
                                }
                            })];
                    case 3:
                        response = _a.sent();
                        productItems = null;
                        if (response.data['priceBookEntryList']) {
                            productItems = response.data['priceBookEntryList'];
                            productItems.unshift({
                                value: ' ',
                                text: String(self_.$t('dictionary.select.default_text')),
                                price: ' '
                            });
                        }
                        // 商品ファミリー「Rehab Cloud アップグレード」のみをフィルターする
                        self_.defaultPriceBookDataObj = productItems.filter(function (value) {
                            return value.family === "Rehab Cloud アップグレード";
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        self_.endLoading();
                        self_.alertDialogMessage = 'アップグレード対応でERRORが発生しています。開発にご連絡下さい1';
                        self_.showAlertDialog = true;
                        return [2 /*return*/];
                    case 5:
                        self_.endLoading();
                        return [2 /*return*/];
                }
            });
        });
    };
    OpportunityUpgradePre.prototype.submit = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var self_;
            return __generator(this, function (_a) {
                self_ = this;
                event.preventDefault();
                if (value_checker_1.default.isBlank(self_.salesForceInfo.torihikisakiId)) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_torihikisaki_id').toString();
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isBlank(self_.salesForceInfo.toUpgradePriceBook2Id)) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_pricebook_id').toString();
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isBlank(self_.salesForceInfo.toUpgradeSelectedItem)) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_select_upgrade_to').toString();
                    return [2 /*return*/];
                }
                // Entryの場合、定員数の入力が必須である。他のプランの場合は、定員数は自動的にSETされる。
                if (value_checker_1.default.isBlank(self_.salesForceInfo.toUpgradeCapacity)) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_select_capacity').toString();
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isBlank(self_.salesForceInfo.toUpgradeStartDate)) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.arert_start_date').toString();
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isBlank(self_.salesForceInfo.toUpradePlanPeriodStr) ||
                    value_checker_1.default.isBlank(self_.salesForceInfo.toUpgradePrice) ||
                    value_checker_1.default.isBlank(self_.salesForceInfo.toUpgradePlanName) ||
                    value_checker_1.default.isBlank(self_.salesForceInfo.toUpgradePeriod) ||
                    value_checker_1.default.isBlank(self_.salesForceInfo.toUpgradeProductId) ||
                    value_checker_1.default.isBlank(self_.salesForceInfo.toUpgradePriceBookMonth)) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('本来自動算出されるべき値がBlankです。開発に連絡してください。').toString();
                    return [2 /*return*/];
                }
                if (this.isTokubetuBlank()) {
                    this.showAlertDialog = true;
                    this.alertMessage = "特別対応の詳細への入力は必須です。";
                    return [2 /*return*/];
                }
                this.confirmMessage = '<strong>申込予定のRehab Cloud アップグレードの商品</strong>を登録します。よろしいですか？';
                this.showConfirmDialog = true;
                return [2 /*return*/];
            });
        });
    };
    OpportunityUpgradePre.prototype.dialogClose = function () {
        this.showConfirmDialog = false;
        this.showAlertDialog = false;
    };
    OpportunityUpgradePre.prototype.reflect = function () {
        var self_ = this;
        self_.dialogClose();
        this.$emit('reflect', this.getAjaxInfo());
    };
    OpportunityUpgradePre.prototype.isTokubetuBlank = function () {
        return value_checker_1.default.isBlank(this.salesForceInfo.toUpgradeTokubetuDetail);
    };
    OpportunityUpgradePre.prototype.getAjaxInfo = function () {
        // カラム追加した項目は、NullCareをしないと、trim()でエラー
        if (!this.salesForceInfo.opportunityToUpgradeId) {
            this.salesForceInfo.opportunityToUpgradeId = '';
        }
        if (!this.salesForceInfo.opportunityToUpgradeItemId) {
            this.salesForceInfo.opportunityToUpgradeItemId = '';
        }
        if (!this.salesForceInfo.torihikisakiId) {
            this.salesForceInfo.torihikisakiId = '';
        }
        return {
            salesForceInfo: {
                torihikisakiId: this.salesForceInfo.torihikisakiId.trim(),
                toUpgradePriceBook2Id: this.salesForceInfo.toUpgradePriceBook2Id,
                opportunityToUpgradeName: this.salesForceInfo.opportunityToUpgradeName,
                opportunityToUpgradeId: this.salesForceInfo.opportunityToUpgradeId,
                opportunityToUpgradeItemId: this.salesForceInfo.opportunityToUpgradeItemId,
                toUpgradeItFlg: this.salesForceInfo.toUpgradeItFlg,
                toUpgradeTokubetuFlg: this.salesForceInfo.toUpgradeTokubetuFlg,
                toUpgradeTokubetuDetail: this.salesForceInfo.toUpgradeTokubetuDetail,
                toUpgradePriceBookData: this.defaultPriceBookDataObj,
                currentContractStartDate: this.salesForceInfo.currentContractStartDate,
                currentContractEndDate: this.salesForceInfo.currentContractEndDate,
                previousPlan: this.salesForceInfo.previousPlan,
                contractPlan: this.salesForceInfo.contractPlan,
                // toUpgradeData: this.upgradeToStandardDataList !== null ? this.salesForceInfo.toUpgradeData : this.upgradeToStandardDataList,
                toUpgradeData: this.upgradeToStandardDataList,
                toUpgradeStartDate: this.salesForceInfo.toUpgradeStartDate,
                toUpgradeSelectedItem: this.salesForceInfo.toUpgradeSelectedItem,
                toUpgradePlanName: this.salesForceInfo.toUpgradePlanName,
                toUpgradeCapacity: this.salesForceInfo.toUpgradeCapacity,
                toUpradePlanPeriodStr: this.salesForceInfo.toUpradePlanPeriodStr,
                toUpgradePrice: this.salesForceInfo.toUpgradePrice,
                toUpgradeProductId: this.salesForceInfo.toUpgradeProductId,
                toUpgradePeriod: this.salesForceInfo.toUpgradePeriod,
                toUpgradeContractEdate: ' ',
                toUpgradeRequestStartDate: ' ',
                toUpgradePriceBookMonth: this.salesForceInfo.toUpgradePriceBookMonth
            },
            reflectType: [ReflectType_1.SalesForceReflectType.OPPORTUNITY_UPGRADE_PRE],
            fetchTypes: [ReflectType_1.SalesForceReflectType.OPPORTUNITY_UPGRADE_PRE]
        };
    };
    __decorate([
        vue_property_decorator_1.Prop({ default: {} })
    ], OpportunityUpgradePre.prototype, "initData", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: {} })
    ], OpportunityUpgradePre.prototype, "initSalesForceData", void 0);
    __decorate([
        vue_property_decorator_1.Prop({
            default: function () {
            }
        })
    ], OpportunityUpgradePre.prototype, "fetchSalesForceInfo", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: [] })
    ], OpportunityUpgradePre.prototype, "priceBookData", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: [] })
    ], OpportunityUpgradePre.prototype, "upgradeToStandardDataList", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: false })
    ], OpportunityUpgradePre.prototype, "isLinkComplete", void 0);
    __decorate([
        vue_property_decorator_1.Watch('initData')
    ], OpportunityUpgradePre.prototype, "initDataChange", null);
    __decorate([
        vue_property_decorator_1.Watch('initSalesForceData')
    ], OpportunityUpgradePre.prototype, "initSalesForceDataChange", null);
    __decorate([
        vue_property_decorator_1.Watch('upgradeToStandardDataList')
    ], OpportunityUpgradePre.prototype, "capacitySelectBoxCtrl", null);
    __decorate([
        vue_property_decorator_1.Watch('salesForceInfo.toUpgradePriceBook2Id')
    ], OpportunityUpgradePre.prototype, "priceBook2IdChanged", null);
    __decorate([
        vue_property_decorator_1.Watch('salesForceInfo.toUpgradeSelectedItem')
    ], OpportunityUpgradePre.prototype, "decideToUpgradePlan", null);
    __decorate([
        vue_property_decorator_1.Watch('salesForceInfo.toUpgradeStartDate')
    ], OpportunityUpgradePre.prototype, "determineToUpgradePlan", null);
    __decorate([
        vue_property_decorator_1.Watch('selectedUpgradeCapacity')
    ], OpportunityUpgradePre.prototype, "determineToUpgradePlanByCapacity", null);
    OpportunityUpgradePre = __decorate([
        vue_property_decorator_1.Component({
            components: {
                ProductSelect: ProductSelect_1.default,
                PriceBookSelect: PriceBookSelect_1.default,
                SimpleDialog: SimpleDialog_1.default,
                MoveSalesForceButton: MoveSalesForceButton_1.default,
                DatePickerWrapper: DatePickerWrapper_1.default,
                Loading: Loading_1.default,
                SalesForceButtonArea: SalesForceButtonArea_1.default,
                DetailDataSingleLabel: DetailDataSingleLabel_1.default
            }
        })
    ], OpportunityUpgradePre);
    return OpportunityUpgradePre;
}(vue_property_decorator_1.Vue));
exports.default = OpportunityUpgradePre;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/sales_force/OpportunityUpgradePre.vue
// module id = jqYj
// module chunks = 1